import facepaint from 'facepaint';

const breakpoints = [540]; //Mobile, Desktop/Tablet

const MQ = facepaint(breakpoints.map((bp) => `@media (min-width: ${bp}px)`));
export default MQ;
